import { createCrudActions } from "../utils/crudGenerator";

const formatDeckTypes = (data) => {
  if (!data) {
    return [];
  }
  const formatItem = (item) => ({
    ...item,
    label: `${item.type}`,
    value: item._id,
  });

  if (Array.isArray(data)) {
    return data.map(formatItem);
  }
  return formatItem(data);
};

export const {
  fetch: fetchDeckTypes,
  create: createDeckType,
  update: updateDeckType,
  delete: deleteDeckTypes,
} = createCrudActions("DECKTYPE", "Arquetipo", formatDeckTypes);
